"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PACK = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * The pack object simply causes any number of elements pack up horizontally to automatically fill an equal, fluid width of their parent.
 */
var Pack = function Pack(_ref) {
  var children = _ref.children,
      className = _ref.className,
      bottom = _ref.bottom,
      middle = _ref.middle,
      noWrap = _ref.noWrap,
      justify = _ref.justify;
  return _react["default"].createElement(PackUl, {
    className: className,
    bottom: bottom,
    middle: middle,
    noWrap: noWrap,
    justify: justify
  }, children);
};

Pack.themeProps = {
  list: {
    name: "PACK",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var position = function position(bottom, middle) {
  if (bottom === true && middle === true) console.warn("Pack cannot be middle and bottom at the same time");else if (bottom === true) return "flex-end";else if (middle === true) return "center";
};

var PACK = "PACK";
exports.PACK = PACK;

var PackUl = _styledComponents["default"].ul.withConfig({
  displayName: "Pack__PackUl",
  componentId: "sc-98edq-0"
})(["width:100%;margin-left:0;display:flex;justify-content:", ";align-items:", ";flex-wrap:", ";", ";"], function (p) {
  return p.justify;
}, function (p) {
  return position(p.bottom, p.middle);
}, function (p) {
  return !p.noWrap && "wrap";
}, (0, _theming.applyVariants)(Pack.themeProps.list));

Pack.defaultProps = {
  className: "",
  bottom: false,
  middle: false,
  noWrap: false,
  justify: "space-between"
};
Pack.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].element), _propTypes["default"].element]).isRequired,
  className: _propTypes["default"].string,
  bottom: _propTypes["default"].bool,
  middle: _propTypes["default"].bool,
  noWrap: _propTypes["default"].bool,
  justify: _propTypes["default"].string
};
var _default = Pack;
exports["default"] = _default;